import {
    takeEvery, all, put, call, select,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/OrganizerPosterList';

function* getCompanyInfo(action) {
    const loadedCompanies = action.payload.mergeOldData
        ? yield select((state) => state.organizerPosterList.getList.data.results) : [];
    const endpoint = `/api/v1/event/${action.payload.event}/company-active/`;
    /*  ★★★　カテゴリタイプの場合、変更箇所 ★★ 
    if (action.payload.event=="JPL24" || action.payload.event=="test001"){
        action.payload.params["page_size"]=100000;
    }
    */
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
                body: action.payload.params,
            },
        );
        yield put(Actions.getCompanyInfoReceived({ ...response, results: [...loadedCompanies, ...response.results] }));
    } catch (error) {
        yield put(Actions.getCompanyInfoReceiveFailure(yield error));
    }
}

export default function* login() {
    yield all([
        takeEvery('GET_COMPANY_INFO_REQUEST', getCompanyInfo),
    ]);
}
